<template>
  <v-dialog v-model="editDialog" persistent width="1024">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark class="mx-4" v-bind="attrs" v-on="on">
        Add Itom Bridge
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-h5 accent lighten-2">
        {{ formTitle }}
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6" class="text-center">
              <v-text-field v-model="editedVersion.itom_bridge_version" label="Version" />
            </v-col>
            <v-col cols="12" sm="6" md="6" class="text-center">
              <v-text-field v-model="editedVersion.itom_bridge_file_name" label="Filename" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close"> CANCEL </v-btn>
        <v-btn color="accent" @click="save"> CONFIRM </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { authHeader } from '@/util/helpers'
  import getEnv from '@/util/env'
  // import { get, sync } from 'vuex-pathify'
  const host = getEnv('VUE_APP_API_HOST')
  export default {
    name: 'ItomBridgeDialog',
    data () {
      return {
        editDialog: false,
        editedIndex: -1,
        editedVersion: {
          itom_bridge_id: '',
          itom_bridge_version: '',
          itom_bridge_file_name: ''
        },
        defaultVersion: {
          itom_bridge_id: '',
          itom_bridge_version: '',
          itom_bridge_file_name: ''
        },
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Itom Bridge' : 'Edit Itom Bridge'
      },
      software () {
        return this.$store.getters['software/itom_bridges']
      }
    },
    methods: {
      editVersion: function (software) {
        this.editedIndex = this.software.indexOf(software)
        this.editedVersion = Object.assign({}, software)
        this.editDialog = true
      },
      close () {
        this.editDialog = false
        this.$nextTick(() => {
          this.editedVersion = Object.assign({}, this.defaultVersion)
          this.editedIndex = -1
        })
      },
      save: function() {
        if (this.editedIndex > -1) {
          this.updateVersion()
        } else {
          this.createVersion()
        }
        this.close()
      },
      updateVersion: function () {
        axios
          .put(
            `${host}/v2/bridges/itom/${this.editedVersion.itom_bridge_id}`,
            this.editedVersion,
            {
              headers: authHeader(),
            }
          )
          .then(() => {
            this.$snackbar.showMessage({ content: 'Itom bridge has been updated', color: 'success', timeout: 5000 })
            this.$store.dispatch('software/load')
          })
          .catch((err) => {
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      createVersion: function () {
        axios
          .post(
            `${host}/v2/bridges/itom/new`,
            this.editedVersion,
            {
              headers: authHeader(),
            }
          )
          .then(() => {
            this.$snackbar.showMessage({ content: 'Itom bridge has been created', color: 'success', timeout: 5000 })
            this.$store.dispatch('software/load')
          })
          .catch((err) => {
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      }
    }
  }
</script>